/** Loss / RLGC vs frequency: sweep controls + small-multiple plots. */
import { design, sweepState, updateDesign, cf, solveState } from "../state/store";
import { NumberField, Select } from "./common";
import { Plot } from "./Plot";

export function RlgcPanel() {
  const st = sweepState.value;
  const s = st.result;
  const sw = design.value.sweep;
  const offLocusFallback = !cf.value.available;

  return (
    <div class="rlgc-panel">
      <div class="sweep-controls">
        <NumberField label="f start" unit="Hz" step={1e6} value={sw.f0} onChange={(f0) => updateDesign((d) => ({ ...d, sweep: { ...d.sweep, f0 } }))} />
        <NumberField label="f stop" unit="Hz" step={1e9} value={sw.f1} onChange={(f1) => updateDesign((d) => ({ ...d, sweep: { ...d.sweep, f1 } }))} />
        <NumberField label="Points" step={50} min={2} value={sw.n} onChange={(n) => updateDesign((d) => ({ ...d, sweep: { ...d.sweep, n: Math.max(2, Math.round(n)) } }))} />
        <Select
          label="Spacing"
          value={sw.log ? "log" : "lin"}
          options={[
            { value: "log", label: "log" },
            { value: "lin", label: "linear" },
          ]}
          onChange={(v) => updateDesign((d) => ({ ...d, sweep: { ...d.sweep, log: v === "log" } }))}
        />
      </div>

      {offLocusFallback && (
        <div class="status-line info">
          Off-locus combined fill: dielectric reduced to the numerically solved εeff
          {solveState.value.result ? ` = ${solveState.value.result.epsEff.toFixed(4)}` : " (waiting for a solve)"} with an
          energy-weighted tanδ estimate.
        </div>
      )}
      {st.status === "running" && <div class="status-line">Sweeping…</div>}
      {st.status === "error" && <div class="status-line error">Sweep failed: {st.error}</div>}

      {s && (
        <div class="plot-grid-wrap">
          <Plot title="Z₀ (magnitude, lossless)" x={s.freq} logX={sw.log} yUnit="Ω" series={[{ y: s.z0, color: "#1976d2" }]} />
          <Plot
            title="Attenuation α"
            x={s.freq}
            logX={sw.log}
            yUnit="dB/m"
            series={[
              { y: s.alpha, color: "#212121", label: "total" },
              { y: s.alphaC, color: "#d32f2f", label: "conductor" },
              { y: s.alphaD, color: "#1976d2", label: "dielectric" },
            ]}
          />
          <Plot title="R′" x={s.freq} logX={sw.log} yUnit="Ω/m" series={[{ y: s.R, color: "#d32f2f" }]} />
          <Plot title="L′" x={s.freq} logX={sw.log} yUnit="H/m" series={[{ y: s.L, color: "#2e7d32" }]} />
          <Plot title="G′" x={s.freq} logX={sw.log} yUnit="S/m" series={[{ y: s.G, color: "#f57c00" }]} />
          <Plot title="C′" x={s.freq} logX={sw.log} yUnit="F/m" series={[{ y: s.C, color: "#6a1b9a" }]} />
        </div>
      )}
    </div>
  );
}
